import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { API_SETTINGS } from './API_SETTINGS';
import { QuestionRule } from '../models/question-rules/QuestionRule';
import { QuestionRuleType } from '../models/question-rules/QuestionRuleType';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrl = API_SETTINGS.API_URL + 'QuestionRule';

@Injectable({
  providedIn: 'root'
})
export class ApiQuestionRuleService {
  
  constructor(private http: HttpClient) { }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getQuestionRules (): Observable<QuestionRule[]> {
    const url = apiUrl +'/GetQuestionRules'
    return this.http.get<QuestionRule[]>(url).pipe();
  }
  
  getQuestionRule(id: number): Observable<QuestionRule> {
    const url = `${apiUrl}/GetQuestionRule/${id}`;
    return this.http.get<QuestionRule>(url).pipe();
  }

  getQuestionRuleTypes(): Observable<QuestionRuleType[]> {
    const url = apiUrl +'/GetQuestionRuleTypes'
    return this.http.get<QuestionRuleType[]>(url).pipe();
  }

  getQuestionRulesWithSceneAssetRelationId(sceneAssetRelationId: number): Observable<QuestionRule[]> {
    const url = `${apiUrl}/GetQuestionRuleWithSceneAssetRelationId/${sceneAssetRelationId}`;
    return this.http.get<QuestionRule[]>(url).pipe();
  }

  getQuestionRulesWithSceneAssetRelationIds(sceneAssetRelationIds: number[]): Observable<QuestionRule[]> {
    const url = apiUrl + '/GetQuestionRuleWithSceneAssetRelationIds';
    return this.http.post<QuestionRule[]>(url, sceneAssetRelationIds, httpOptions).pipe();
  }

  addQuestionRule(questionRule: QuestionRule): Observable<QuestionRule>{  
    const url = apiUrl +'/PostQuestionRule';
    return this.http.post<QuestionRule>(url, questionRule, httpOptions).pipe();
  }
  
  updateQuestionRule (id: number, questionRule: any): Observable<QuestionRule>{
     const url = `${apiUrl}/PutQuestionRule/${id}`;
    return this.http.put(url, questionRule, httpOptions).pipe(
      tap((questionRuleRes: QuestionRule) => true ), //console.log()),
      catchError(this.handleError<QuestionRule>('updateQuestionRule'))
    )
  }

  deleteQuestionRule(id: number): Observable<QuestionRule> {
    const url = `${apiUrl}/DeleteQuestionRule/${id}`;
    return this.http.delete<QuestionRule>(url, httpOptions).pipe();
  }

}
